export var stringOrUndefined = function(value) {
    return typeof value === "string" ? value : undefined;
};
